import React from 'react';

import renderAutoSuggestWithOptions from 'app/employer/components/autoSuggest/AutoSuggestHOC';
import { changeLogAutoCompleteInput$, changeLogAutoCompleteObservable$ } from 'app/employer/redux/autosuggest/autoCompleteService';

const renderSuggestion = (suggestion) => {
   return (
      <div>
         {' '}
         {suggestion.text}
         {' '}
      </div>
   );
};

const ChangeLogAutoSuggest = renderAutoSuggestWithOptions(
   changeLogAutoCompleteObservable$,
   changeLogAutoCompleteInput$,
   renderSuggestion,
);

ChangeLogAutoSuggest.defaultProps = {
   selected: {
      id: null,
      label: '',
      description: '',
      userId: null,
   },
   forceSelection: false,
   placeholder: 'Search Users ...',
};

export default ChangeLogAutoSuggest;
